import React from 'react';
import { motion } from 'framer-motion';
interface FadeInUpProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  yOffset?: number;
}
export function FadeInUp({
  children,
  className = '',
  delay = 0,
  yOffset = 30
}: FadeInUpProps) {
  return <motion.div initial={{
    opacity: 0,
    y: yOffset
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.8,
    delay,
    ease: [0.21, 0.47, 0.32, 0.98]
  }} className={className} data-id="element-311">
      {children}
    </motion.div>;
}